import SelectSchoolModal from './SelectSchoolModal.component';

export default SelectSchoolModal;